import type { ConfigType } from '@plone/registry';
import EditalSVG from '@plone/volto/icons/spreadsheet.svg';
import PersonSVG from '@plone/volto/icons/user.svg';
import ServiceSVG from '@plone/volto/icons/summary.svg';
import VideoSVG from '@plone/volto/icons/video.svg';
import AreaSVG from '@plone/volto/icons/cards.svg';
import EditalView from '@ifpb/portal/components/Views/EditalView';
import FileView from '@ifpb/portal/components/Views/FileView';
import PersonView from '@ifpb/portal/components/Views/PersonView';
import ServicoView from '@ifpb/portal/components/Views/ServicoView';
import VideoView from '@ifpb/portal/components/Views/VideoView';

function installPerson(config: ConfigType) {
  config.settings.contentIcons.Person = PersonSVG;
  return config;
}

function installEdital(config: ConfigType) {
  config.settings.contentIcons.Edital = EditalSVG;
  return config;
}

function installService(config: ConfigType) {
  config.settings.contentIcons.Service = ServiceSVG;
  return config;
}
function installVideo(config: ConfigType) {
  config.settings.contentIcons.Video = VideoSVG;
  return config;
}

function installArea(config: ConfigType) {
  config.settings.contentIcons.Area = AreaSVG;
  return config;
}

export default function install(config: ConfigType) {
  // Views
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Edital: EditalView,
    File: FileView,
    Person: PersonView,
    Servico: ServicoView,
    Video: VideoView,
  };
  // Content Types
  installEdital(config);
  installPerson(config);
  installService(config);
  installVideo(config);
  installArea(config);
  return config;
}
